import { useEffect, useState } from "react";

/** True while `query` matches (SSR-safe, updates on resize/orientation change). */
export const useMediaQuery = (query) => {
  const get = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
};

/** Tailwind `lg` breakpoint and up (desktop sidebar visible). */
export const useIsDesktop = () => useMediaQuery("(min-width: 1024px)");
/** Below Tailwind `sm` (phones in portrait). */
export const useIsPhone = () => useMediaQuery("(max-width: 639px)");
